import { useToast } from '@chakra-ui/core'
import { RootState } from 'constants/interfaces'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { checkKeyExists, formatBytes, getFileExtension } from 'utils'

const warningMessage =
  'The file you selected is too large, or the file has an extantion that is not supported. This file can not be uploaded!'

export const useFileValidation = () => {
  const retailConfig = useSelector((state: RootState) => state.config.retailConfig)
  const toast = useToast()
  const fileSizeAndExtensionMap = retailConfig?.file_extension_to_max_size_map

  const getFileValidationError = useCallback(
    (file: File): string | undefined => {
      const fileExtension = getFileExtension(file.name).toLowerCase()

      if (!fileSizeAndExtensionMap || !checkKeyExists(fileSizeAndExtensionMap, fileExtension)) {
        return 'This file type is not supported. Choose a different file.'
      }

      const maxFileSize = fileSizeAndExtensionMap[fileExtension]

      if (file.size > maxFileSize) {
        return `This file is too large. The maximum size for .${fileExtension} files is ${formatBytes(maxFileSize)}.`
      }

      return undefined
    },
    [fileSizeAndExtensionMap]
  )

  const fileSizeValidation = useCallback(
    (file: File) => {
      if (getFileValidationError(file)) {
        toast({ title: warningMessage, duration: 5000, isClosable: true })
        return false
      }

      return true
    },
    [getFileValidationError, toast]
  )

  return {
    fileSizeValidation,
    getFileValidationError,
  }
}
